export class ResponsiveTable {

    constructor(tableEl: HTMLTableElement) {
        tableEl.setAttribute('role', 'table');
        const tbody = tableEl.querySelector('tbody');
        tbody.setAttribute('role', 'rowgroup');
        const rows = [].slice.call(tableEl.rows) as Array<HTMLTableRowElement>;
        let matrix = [];
        let columnHeaders = {};
        let rowHeaders = {};
        let headerRowStyle = "";

        // Index each cell, set accessible roles, and find and index any headings
        rows.forEach((row, rowIndex) => {
            row.setAttribute('role', 'row');
            matrix[rowIndex] = [].slice.call(row.cells);
            let realColumnIndex = 0;
            matrix[rowIndex].forEach((cell, columnIndex) => {
                if (cell.nodeName.toLowerCase() == 'th') {
                    switch (cell.getAttribute('scope')) {
                        case 'row':
                            cell.setAttribute('role', 'rowheader');
                            rowHeaders[rowIndex] = cell.innerHTML;
                            break;
                        case 'colgroup':
                            columnHeaders[realColumnIndex] = cell.innerHTML;
                            if (cell.hasAttribute('colspan')) {
                                const colspan = parseInt(cell.getAttribute('colspan'));
                                for (var i = 1; i <= colspan; i++) {
                                    columnHeaders[columnIndex + i] = cell.innerHTML;
                                }
                                realColumnIndex += colspan - 1;
                            }
                            break;
                        case 'rowgroup':
                            cell.setAttribute('role', 'rowgroupheader');
                            rowHeaders[rowIndex] = cell.innerHTML;
                            if (cell.hasAttribute('rowspan')) {
                                const rowspan = parseInt(cell.getAttribute('rowspan'));
                                for (var i = 0; i < rowspan; i++) {
                                    rowHeaders[rowIndex + i] = cell.innerHTML;
                                }
                            }
                            break;
                        default:
                            cell.setAttribute('role', 'columnheader');
                            columnHeaders[realColumnIndex] = cell.innerHTML;
                            if (cell.parentElement.className != "") {
                                headerRowStyle = cell.parentElement.className;
                            }
                            break;
                    }
                }
                else {
                    cell.setAttribute('role', 'cell');
                }
                realColumnIndex++;
            });
        });

        // Apply headers
        matrix.forEach((row, rowIndex) => {
            row.forEach((cell, columnIndex) => {
                if (cell.nodeName.toLowerCase() == 'td') {
                    cell.innerHTML = cell.innerHTML.replace('&nbsp;', '');
                    let headers = [];
                    let thisHeaderStyle = headerRowStyle;
                    if (rowHeaders[rowIndex]) headers.push(rowHeaders[rowIndex]);
                    if (columnHeaders[columnIndex]) headers.push(columnHeaders[columnIndex]);
                    const headerString = headers.join(", ");
                    if (headerString.indexOf('<strong>') > -1) {
                        thisHeaderStyle += " bold";
                    }
                    if (headerString.indexOf('<em>') > -1) {
                        thisHeaderStyle += " italic";
                    }
                    cell.setAttribute('data-cell-headers', cleanText(headerString));
                    if (thisHeaderStyle) {
                        cell.setAttribute('data-header-style', thisHeaderStyle);
                    }
                }
            })
        })
    }
}

function cleanText(header: string) {
    let cleanHeader = header.replace('&nbsp;', '')
        .replace('<p>&nbsp;</p>', '')
        .replace(/<br>/g, '\n')
        .replace(/<br \/>/g, '\n')
        .replace(/<strong>/g, '')
        .replace(/<\/strong>/g, '')
        .replace(/<em>/g, '')
        .replace(/<\/em>/g, '')
        .replace(/<\/?p.*?>/g, '');
    return cleanHeader;
}